import { useShowOreaAuthDialog } from './AppSplashDialogs/hooks/useShowOreaAuthDialog';
import { OreaAuthDialogContainer } from './AppSplashDialogs/OreaAuthDialog/OreaAuthDialogContainer';

export const OreaAuthPopupDialog = () => {
  const { show } = useShowOreaAuthDialog();
  if (show) {
    return <OreaAuthDialogContainer />;
  }
  return null;
};
